export const DATA_TEST_ID_VERTICAL_LIST = 'vertical-list';
export const DATA_TEST_ID_FAVOURITE_AREA = 'favourite-area';
export const DATA_TEST_ID_FAVOURITE_ICON_ACTIVE = 'favourite-icon-active';
export const DATA_TEST_ID_FAVOURITE_ICON_INACTIVE = 'favourite-icon-inactive';
